import React, { Fragment } from "react";
import moment from "moment";
import Select from "react-select";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Table,
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  UncontrolledCollapse,
} from "reactstrap";
import {
  MdDeleteForever,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdEdit,
} from "react-icons/md";
import Page from "../components/Page";
import * as Server from "../Server";
import ScheduleEdit from "./ScheduleEdit";
import PageSpinner from "../components/PageSpinner";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import { GlobalContext } from "../components/Layout/MainLayout";

let selectedScheduleId = "";
export default class Schedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      schedules: [],
      page: 1,
      limit: 10,
      totalSchedules: 0,
      pages: 0,
      pageNumbers: [],
      removeScheduleConfirmationModal: false,
      scheduleEditKey: "",
      scheduleDetail: "",
      filterCollapse: true,
      scheduleEditPage: false,
      camps: [],
      teams: [],
      selectedCampForAPI: [
        {
          label: "All",
          value: "all",
        },
      ],
      selectedTeamForAPI: [
        {
          label: "All",
          value: "all",
        },
      ],
      fromDate: new Date().setUTCDate(1),
      toDate: new Date(),
    };
  }
  componentDidMount() {
    this.setState({ limit: this.context.limit }, () => this.getCamps());
  }

  getCamps = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "camp/web/list",
        method: "GET",
      });
      if (response && response.camps.length > 0) {
        this.setState({
          showLoader: false,
          camps: response.camps,
        });
        this.getTeams(true);
      } else {
        this.setState({ showLoader: false });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getTeams = async (callGetSchedule) => {
    try {
      let teamIds = [];
      if (this.state.selectedCampForAPI.find((camp) => camp.value === "all")) {
        teamIds = [
          ...new Set(
            this.state.camps.reduce((preVal, curVal) => {
              preVal.push(...curVal.teams);
              return preVal;
            }, [])
          ),
        ];
      } else {
        let campIds = this.state.selectedCampForAPI.map((camp) => camp.value);
        let camps = this.state.camps.filter((camp) =>
          campIds.includes(camp._id)
        );
        teamIds = [
          ...new Set(
            camps.reduce((preVal, curVal) => {
              preVal.push(...curVal.teams);
              return preVal;
            }, [])
          ),
        ];
      }
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/camp/teamlist",
        method: "POST",
        data: { teamIds },
      });
      if (response) {
        this.setState(
          {
            showLoader: false,
            teams: response.teams,
          },
          () => {
            callGetSchedule && this.getSchedules();
          }
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getSchedules = async (event) => {
    if (event) event.preventDefault();
    try {
      let page = this.state.page;
      let pageLimit = this.state.limit;
      let campIds = this.state.selectedCampForAPI.find(
        (camp) => camp.value === "all"
      )
        ? this.state.camps.map((camp) => camp._id)
        : this.state.selectedCampForAPI.map((camp) => camp.value);
      let teamIds = this.state.selectedTeamForAPI.find(
        (team) => team.value === "all"
      )
        ? this.state.teams.map((team) => team._id)
        : this.state.selectedTeamForAPI.map((team) => team.value);
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/schedulelist",
        method: "POST",
        data: {
          page,
          pageLimit,
          teamIds,
          campIds,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          schedules: response.schedules,
          totalSchedules: response.totalSchedules,
          pages: response.pages,
        });
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        this.setState({ pageNumbers: pageNumbers });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  refreshPagination = (page, limit) => {
    this.setState({ page: parseInt(page, 10), limit: limit }, () => {
      this.getSchedules();
    });
  };

  toggleRemoveScheduleConfirmationModal = (id) => {
    if (!selectedScheduleId && id) {
      selectedScheduleId = id;
    }
    this.setState({
      removeScheduleConfirmationModal: !this.state
        .removeScheduleConfirmationModal,
    });
  };

  removeSchedule = async (id) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/schedule/delete",
        method: "POST",
        data: { scheduleId: selectedScheduleId },
      });
      if (response) {
        this.setState({ showLoader: false });
        selectedScheduleId = null;
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.getSchedules();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  renderEditPage(schedule, key) {
    if (key === "Create-Schedule") {
      this.setState({ scheduleEditPage: true, scheduleEditKey: key, schedule });
    } else {
      this.setState({
        scheduleEditPage: true,
        scheduleEditKey: key,
        scheduleDetail: schedule,
      });
    }
  }

  closeEditPage() {
    this.setState({
      scheduleEditPage: false,
    });
    this.getSchedules();
  }

  render() {
    return (
      <Fragment>
        {this.state.scheduleEditPage ? (
          <ScheduleEdit
            schedule={this.state.schedule || null}
            scheduleEdit={
              this.state.scheduleEditKey === "Create-Schedule" ? false : true
            }
            scheduleEditKey={this.state.scheduleEditKey}
            closeEditPage={() => this.closeEditPage()}
          ></ScheduleEdit>
        ) : (
          <div>
            <PageSpinner showLoader={this.state.showLoader} />
            <Page
              title="Schedule"
              breadcrumbs={[{ name: "Schedule", active: true }]}
            >
              <Row style={{ marginTop: 10 }}></Row>
              <Row>
                <Col>
                  <Card className="mb-3">
                    <CardHeader>
                      <Row>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex">
                            <div sm={4} className="mt-2 pr-2">
                              <Label>Shown</Label>
                            </div>
                            <div sm={4}>
                              <Input
                                type="select"
                                name="pageLimit"
                                value={this.state.limit}
                                onChange={(event) => {
                                  this.refreshPagination(1, event.target.value);
                                  this.context.updateState({
                                    limit: event.target.value,
                                  });
                                }}
                              >
                                <option value={10}>10</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                              </Input>
                            </div>
                            <div sm={4} className="mt-2 pl-2">
                              <Label>entries</Label>
                            </div>
                          </div>
                        </Col>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex justify-content-center">
                            <div className="mt-2 pr-2">
                              Showing{" "}
                              {!this.state.totalSchedules
                                ? 0
                                : this.state.page * this.state.limit -
                                  (this.state.limit - 1)}{" "}
                              to{" "}
                              {this.state.page * this.state.limit >
                              this.state.totalSchedules
                                ? this.state.totalSchedules
                                : this.state.page * this.state.limit}{" "}
                              of {this.state.totalSchedules}
                            </div>
                          </div>
                        </Col>
                        <Col xl={4} lg={12} md={12}>
                          <div className="d-flex justify-content-end">
                            <div sm={4} className="pr-2">
                              <Button
                                className="rounded-circle"
                                disabled={this.state.page <= 1}
                                onClick={(event) =>
                                  this.refreshPagination(
                                    this.state.page - 1,
                                    this.state.limit
                                  )
                                }
                              >
                                <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                              </Button>
                            </div>
                            <div sm={4}>
                              <Input
                                type="select"
                                value={this.state.page}
                                name="filter"
                                onChange={(event) => {
                                  this.refreshPagination(
                                    event.target.value,
                                    this.state.limit
                                  );
                                }}
                              >
                                {this.state.pageNumbers.length !== 0 ? (
                                  this.state.pageNumbers.map(
                                    (pageNumber, index) => (
                                      <option value={pageNumber} key={index}>
                                        {pageNumber}
                                      </option>
                                    )
                                  )
                                ) : (
                                  <option value={0}>0</option>
                                )}
                              </Input>
                            </div>
                            <div sm={4} className="pl-2">
                              <Button
                                className="rounded-circle"
                                disabled={this.state.page >= this.state.pages}
                                onClick={(event) =>
                                  this.refreshPagination(
                                    this.state.page + 1,
                                    this.state.limit
                                  )
                                }
                              >
                                <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <div className="d-flex justify-content-end">
                            <Button
                              id="toggler1"
                              className="mr-1"
                              style={{ float: "right", marginBottom: "10px" }}
                              onClick={() => {
                                this.setState({
                                  filterCollapse: !this.state.filterCollapse,
                                });
                              }}
                            >
                              Filters
                            </Button>
                            <Button
                              style={{ float: "right", marginBottom: "10px" }}
                              onClick={(event) =>
                                this.renderEditPage(null, "Create-Schedule")
                              }
                            >
                              Create Schedule
                            </Button>
                          </div>
                        </Col>
                      </Row>
                      <UncontrolledCollapse
                        toggler="#toggler1"
                        isOpen={this.state.filterCollapse}
                      >
                        <Card>
                          <CardBody>
                            <Form
                              className="form"
                              onSubmit={(event) => this.getSchedules(event)}
                            >
                              <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <Label>From Date:</Label>
                                  <Input
                                    type="date"
                                    name="fromDate"
                                    required
                                    placeholder="fromDate"
                                    defaultValue={
                                      moment(
                                        new Date(this.state.fromDate)
                                      ).format("YYYY-MM-DD") || ""
                                    }
                                    value={
                                      moment(
                                        new Date(this.state.fromDate)
                                      ).format("YYYY-MM-DD") || ""
                                    }
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState({
                                        fromDate: event.target.value,
                                      });
                                    }}
                                  />
                                </Col>
                              </Row>
                              <Row className="mt-3">
                                <Col xl={6} lg={12} md={12}>
                                  <Label>To Date:</Label>
                                  <Input
                                    type="date"
                                    name="toDate"
                                    required
                                    placeholder="toDate"
                                    defaultValue={
                                      moment(
                                        new Date(this.state.toDate)
                                      ).format("YYYY-MM-DD") || ""
                                    }
                                    value={
                                      moment(
                                        new Date(this.state.toDate)
                                      ).format("YYYY-MM-DD") || ""
                                    }
                                    onChange={(event) => {
                                      event.persist();
                                      this.setState({
                                        toDate: event.target.value,
                                      });
                                    }}
                                  />
                                </Col>
                              </Row>
                              <Row className="mt-3">
                                <Col
                                  xl={6}
                                  lg={12}
                                  md={12}
                                  style={{ paddingRight: "0px" }}
                                >
                                  <FormGroup>
                                    <Label>Select Event :</Label>
                                    <Select
                                      isMulti
                                      value={this.state.selectedCampForAPI}
                                      options={[
                                        {
                                          value: "all",
                                          label: "All",
                                        },
                                        ...this.state.camps.map((camp) => ({
                                          value: camp._id,
                                          label: camp.name,
                                        })),
                                      ]}
                                      onChange={(result) =>
                                        this.setState(
                                          {
                                            selectedCampForAPI: result,
                                          },
                                          () => this.getTeams()
                                        )
                                      }
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col
                                  xl={6}
                                  lg={12}
                                  md={12}
                                  style={{ paddingRight: "0px" }}
                                >
                                  <FormGroup>
                                    <Label>Select Team :</Label>
                                    <Select
                                      isMulti
                                      value={this.state.selectedTeamForAPI}
                                      options={[
                                        {
                                          value: "all",
                                          label: "All",
                                        },
                                        ...this.state.teams.map((team) => ({
                                          value: team._id,
                                          label: team.name,
                                        })),
                                      ]}
                                      onChange={(result) => {
                                        this.setState({
                                          selectedTeamForAPI: result,
                                        });
                                      }}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>

                              <Row>
                                <Col xl={6} lg={12} md={12}>
                                  <FormGroup>
                                    <Button
                                      className="mr-3"
                                      color="primary"
                                      type="submit"
                                    >
                                      Filter
                                    </Button>
                                    <Button
                                      onClick={() =>
                                        this.setState(
                                          {
                                            selectedCampForAPI: [
                                              {
                                                label: "All",
                                                value: "all",
                                              },
                                            ],
                                            selectedTeamForAPI: [
                                              {
                                                label: "All",
                                                value: "all",
                                              },
                                            ],
                                            fromDate: moment(
                                              new Date().setUTCDate(1)
                                            ).format("YYYY-MM-DD"),
                                            toDate: moment(new Date()).format(
                                              "YYYY-MM-DD"
                                            ),
                                          },
                                          () => this.getTeams()
                                        )
                                      }
                                    >
                                      Reset Filter
                                    </Button>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Form>
                          </CardBody>
                        </Card>
                      </UncontrolledCollapse>
                      <Table striped hover responsive>
                        <thead>
                          <tr>
                            <th>Event</th>
                            <th>Team Name</th>
                            <th>Date</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Location</th>
                            <th>Note</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.schedules &&
                          this.state.schedules.length > 0 ? (
                            this.state.schedules.map((schedule, index) => (
                              <tr key={index}>
                                <td>{schedule.campName}</td>
                                <td>
                                  {schedule.firstTeam
                                    ? schedule.firstTeam
                                    : "-"}
                                </td>
                                <td>
                                  {moment
                                    .utc(schedule.date)
                                    .format("MM-DD-YYYY")}
                                </td>
                                <td>{schedule.startTime || "-"}</td>
                                <td>{schedule.endTime || "-"}</td>
                                <td>{schedule.location}</td>
                                <td>{schedule.note || "-"}</td>
                                <td className="d-flex">
                                  <Button
                                    onClick={(event) => {
                                      this.setState({
                                        scheduleEditPage: true,
                                        schedule,
                                      });
                                      this.renderEditPage(
                                        schedule,
                                        "Update-Schedule"
                                      );
                                    }}
                                  >
                                    <MdEdit size="20px"></MdEdit>
                                  </Button>
                                  <Button
                                    style={{ marginLeft: "10px" }}
                                    onClick={(event) => {
                                      this.toggleRemoveScheduleConfirmationModal(
                                        schedule._id
                                      );
                                    }}
                                  >
                                    <MdDeleteForever size="20px"></MdDeleteForever>
                                  </Button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No schedule found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </CardBody>
                    {this.state.removeScheduleConfirmationModal ? (
                      <Modal
                        isOpen={this.state.removeScheduleConfirmationModal}
                        toggle={(event) =>
                          this.toggleRemoveScheduleConfirmationModal()
                        }
                        className="modal-md"
                      >
                        <ModalHeader
                          toggle={(event) =>
                            this.toggleRemoveScheduleConfirmationModal()
                          }
                        ></ModalHeader>
                        <ModalBody>
                          Are you sure you want to delete this schedule ?
                        </ModalBody>
                        <ModalFooter>
                          <Button
                            color="secondary"
                            onClick={(event) =>
                              this.toggleRemoveScheduleConfirmationModal()
                            }
                          >
                            Cancel
                          </Button>
                          <Button
                            color="primary"
                            onClick={(event) => {
                              this.removeSchedule(selectedScheduleId);
                              this.toggleRemoveScheduleConfirmationModal();
                            }}
                          >
                            Delete
                          </Button>
                        </ModalFooter>
                      </Modal>
                    ) : null}
                  </Card>
                </Col>
              </Row>
              <NotificationSystem
                dismissible={false}
                ref={(notificationSystem) =>
                  (this.notificationSystem = notificationSystem)
                }
                style={NOTIFICATION_SYSTEM_STYLE}
              />
            </Page>
          </div>
        )}
      </Fragment>
    );
  }
}
Schedule.contextType = GlobalContext;
